{
    "table_header__location": "Site",
    "table_header__unit": "Unité",
    "table_header__inventory": "Stock",
    "table_header__reserved": "Réservé",
    "table_header__picked": "Préparé",
    "table_header__effective_inventory": "Stock disponible"
}
